import { render, staticRenderFns } from "./StockTake.vue?vue&type=template&id=7a68f95c&scoped=true&lang=pug&"
import script from "./StockTake.vue?vue&type=script&lang=js&"
export * from "./StockTake.vue?vue&type=script&lang=js&"
import style0 from "./StockTake.vue?vue&type=style&index=0&id=7a68f95c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a68f95c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCol,VDivider,VList,VListItem,VListItemTitle,VMenu,VRow,VSkeletonLoader})
